import { FC } from 'react';
import { Feed } from '../components/Feed';

export const CreateFeed: FC = () => (
    <Feed type="create" />
);
